export const isValidClinicInput = (input: string) => {
  const invalidCharacters = /^[^%<>]*$/;
  return invalidCharacters.test(input);
};
